import PharmacyPage from "./PharmacyPage";

export default PharmacyPage;

export * from "./PharmacyPage";
